import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { DSSProvider } from './DSSContext';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap-icons/font/bootstrap-icons.css";
import { AuthProvider } from './auth-provider/providers/auth-provider/auth-provider';
import { ModalProvider } from './ui/building-blocks/molecule/alert-confirm-modal/context/ModalProvider';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
document.getElementById('root')?.setAttribute('class', 'dark');
root.render(
  <DSSProvider>

    <BrowserRouter>
      <React.StrictMode>
        <AuthProvider>
          <ModalProvider>
            <Routes>
              <Route path='/*' element={<App />} />
            </Routes>
          </ModalProvider>
        </AuthProvider>
      </React.StrictMode>
    </BrowserRouter>


  </DSSProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
